import { LeaderboardBrand } from "../../leaderboard/Leaderboard";
import "./index.scss";
interface CoinProps {
  brand: LeaderboardBrand;
}
export const Coin = ({ brand }: CoinProps) => {
  if (brand === LeaderboardBrand.CSGOROLL) {
    return (
      <span className="csgoroll-coin">
        <div>
          <img src="/assets/coin.png" alt="Coin" />
        </div>
      </span>
    );
  }
  return (
    <span className="hypedrop-dollar">
      <div>
        <img src="/assets/dollar.png" alt="Dollar" />
      </div>
    </span>
  );
};
